import {
  Ship,
  Search,
  FileText,
  Package,
  BarChart3,
  AlertCircle,
  ClipboardCheck,
  Settings,
  Shield,
  Megaphone,
  Zap,
  HelpCircle,
  ArrowLeftRight,
  Carrot,
  Users,
  Building2,
  PackageX,
  Ticket,
  Wrench,
  Bell,
  ShoppingCart,
  User,
  type LucideIcon,
} from "lucide-react";

/**
 * Icon registry keyed by `navigationTag` values from the DynamicWeb API.
 * Nodes with an empty or missing navigationTag will fall back to the default icon (FileText).
 */
export const navigationIconMap: Record<string, LucideIcon> = {
  // QuickLinks tags
  "UnitSearch_Link": Ship,
  "PartsSearch_Link": Search,
  "DealersOrders_Link": FileText,
  "PartsInvoice_Link": Package,
  "Spiffs_Link": AlertCircle,
  "Reports": BarChart3,
  "Reports_Link": BarChart3,
  "ClaimsAndPreAuths_Link": ClipboardCheck,
  "WarrantyRegistration_Link": Settings,
  "ServiceCampaigns_Link": Megaphone,

  // MainMenu top-level tags
  "Parts": Package,
  "Units": Ship,
  "Service": Wrench,
  "Sales": AlertCircle,
  "MessageBoard": FileText,
  "DigitalAssets": FileText,

  // MainMenu child tags
  "ShopRvParts": Search,
  "QuickOrder": Zap,
  "UnknownPartRequest": HelpCircle,
  "UnitSearch": Ship,
  "InventoryTransfers": ArrowLeftRight,
  "ServiceCampaigns": Megaphone,
  "Rgas": PackageX,
  "ClaimsAndPreAuths": ClipboardCheck,
  "YourTickets": Ticket,
  "LaborOperationsLibrary": Wrench,
  "WarrantyRegistration": Shield,
  "MyClaimedSpiffs": Carrot,
  "DealerClaimedSpiffs": Carrot,
  "SalesPersonSpiffs": Users,
  "DealerSpiffs": Building2,
  "DealerInvoices": FileText,

  // ServiceMenu icons (used by mock data / ActionButtons)
  "AddVin": Ship,
  "Notifications": Bell,
  "Cart": ShoppingCart,
  "ShoppingCart": ShoppingCart,
  "MyAccount": User,
  "Dealership": Building2,
  "MyDealership": Building2,
  "UnitsOnLot": Ship,
  "MyDealershipInfo": Building2,
};

export function getNavIcon(key: string): LucideIcon {
  // Strip "_Link" suffix so QuickLinks tags resolve to the same icons as MainMenu tags
  const normalised = key.endsWith('_Link') ? key.slice(0, -5) : key;
  return navigationIconMap[normalised] ?? navigationIconMap[key] ?? FileText;
}
